/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FileDescriptor } from './fileDescriptor';
import { FolderDescriptor } from './folderDescriptor';
import { SecurityDescriptor } from './securityDescriptor';

export interface FoldersResponseInner { 
    entity_kind: FoldersResponseInner.EntityKindEnum;
    entity: FileDescriptor | FolderDescriptor;
    security: Array<SecurityDescriptor>;
}
export namespace FoldersResponseInner {
    export type EntityKindEnum = 'folder_descriptor' | 'file_descriptor';
    export const EntityKindEnum = {
        FolderDescriptor: 'folder_descriptor' as EntityKindEnum,
        FileDescriptor: 'file_descriptor' as EntityKindEnum
    };
}